const CustomEditor = require("react-draft-wysiwyg").Editor;

export default CustomEditor;